var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import EmblaCarousel from 'embla-carousel';
import { addPrevNextBtnsClickHandlers } from '../helpers/emblaControls';
const cartDrawerRecommendations = () => {
    const selectors = {
        cartDrawerRecommendationsCarousel: '[data-cart-drawer-recommendations-carousel]',
        cartDrawerRecommendationsCarouselViewport: '[data-cart-drawer-recommendations-carousel-viewport]',
        cartDrawerRecommendationsCarouselPrev: '[data-cart-drawer-recommendations-carousel-prev]',
        cartDrawerRecommendationsCarouselNext: '[data-cart-drawer-recommendations-carousel-next]',
        recommendation: '[data-recommendation]',
        recommendationSelect: '[data-recommendation-select]',
        recommendationImage: '[data-recommendation-image]',
        recommendationPrice: '[data-recommendation-price]',
        recommendationIndex: 'data-recommendation-index',
        variantID: 'data-variant-id',
        variantTitle: 'data-variant-title',
        variantImage: 'data-variant-image',
        variantPrice: 'data-variant-price',
        variantPriceWithoutCurrency: 'data-variant-price-without-currency',
        variantSKU: 'data-variant-sku',
        defaultImage: 'data-default-image',
        addToCart: '[data-recommendation-add-to-cart]',
        dynamicRecommendationsContainer: '[data-cart-drawer-dynamic-recommendations]',
    };
    const classes = {
        recommendationLoading: 'product-recommendation--loading',
    };
    const dynamicRecommendations = () => __awaiter(void 0, void 0, void 0, function* () {
        const dynamicRecommendationsContainer = document.querySelector(selectors.dynamicRecommendationsContainer);
        if (!dynamicRecommendationsContainer) {
            return;
        }
        try {
            const response = yield fetch('/cart.js');
            const data = yield response.json();
            if (data.items.length) {
                // Get Most Recent Item
                const mostRecentItemID = data.items[0].product_id;
                if (mostRecentItemID) {
                    // Get Section with Recommendations
                    const recommendationsResponse = yield fetch(`${window.Shopify.routes.root}recommendations/products?product_id=${mostRecentItemID}&limit=10&section_id=cart-drawer-dynamic-recommendations&intent=related`);
                    const text = yield recommendationsResponse.text();
                    const textHTML = new DOMParser().parseFromString(text, 'text/html');
                    const innerDivs = textHTML.querySelectorAll('.product-recommendation');
                    let recommendationsHTML = '';
                    innerDivs.forEach((div) => {
                        recommendationsHTML += div.outerHTML;
                    });
                    dynamicRecommendationsContainer.innerHTML = recommendationsHTML;
                }
            }
            else {
                // Cart is Empty
            }
        }
        catch (err) {
            console.error(err);
        }
    });
    const recommendedProductsCarousel = () => {
        const recommendationsCarousel = document.querySelector(selectors.cartDrawerRecommendationsCarousel);
        if (recommendationsCarousel) {
            const viewportNode = recommendationsCarousel.querySelector(selectors.cartDrawerRecommendationsCarouselViewport);
            const prevButtonNode = recommendationsCarousel.querySelector(selectors.cartDrawerRecommendationsCarouselPrev);
            const nextButtonNode = recommendationsCarousel.querySelector(selectors.cartDrawerRecommendationsCarouselNext);
            const options = {
                loop: true,
                align: 'start',
                skipSnaps: true,
            };
            const embla = EmblaCarousel(viewportNode, options);
            const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(embla, prevButtonNode, nextButtonNode);
            const recommendations = recommendationsCarousel.querySelectorAll(selectors.recommendation);
            if (recommendations) {
                recommendations.forEach((recommendation) => {
                    const selector = recommendation.querySelector(selectors.recommendationSelect);
                    const imageContainer = recommendation.querySelector(selectors.recommendationImage);
                    const priceContainer = recommendation.querySelector(selectors.recommendationPrice);
                    const addToCart = recommendation.querySelector(selectors.addToCart);
                    if (selector) {
                        selector.addEventListener('change', () => {
                            const variantID = selector.selectedOptions[0].getAttribute(selectors.variantID);
                            const variantPrice = selector.selectedOptions[0].getAttribute(selectors.variantPrice);
                            const variantImage = selector.selectedOptions[0].getAttribute(selectors.variantImage);
                            if (variantImage != '') {
                                imageContainer.querySelector('img').src = variantImage;
                            }
                            else {
                                const defaultImage = selector.selectedOptions[0].getAttribute(selectors.defaultImage);
                                imageContainer.querySelector('img').src = defaultImage;
                            }
                            priceContainer.innerHTML = variantPrice;
                            addToCart.setAttribute('data-variant', variantID);
                        });
                    }
                    if (addToCart) {
                        addToCart.addEventListener('click', () => {
                            recommendation.classList.add(classes.recommendationLoading);
                            const variant = addToCart.getAttribute('data-variant');
                            const quickAddData = {
                                id: variant,
                                quantity: 1,
                            };
                            fetch('/cart.js', {})
                                .then((response) => {
                                return response.json();
                            })
                                .then((response) => {
                                const currency = response.currency;
                                const items_subtotal_price = response.items_subtotal_price;
                                fetch('/cart/add.js', {
                                    body: JSON.stringify(quickAddData),
                                    credentials: 'same-origin',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Requested-With': 'xmlhttprequest',
                                    },
                                    method: 'POST',
                                })
                                    .then(() => {
                                    // Data Layers
                                    window.dataLayer.push({ ecommerce: null });
                                    const index = recommendation.getAttribute(selectors.recommendationIndex);
                                    const itemName = recommendation.querySelector('.details__title').innerHTML;
                                    const itemVariant = selector.selectedOptions[0].getAttribute(selectors.variantTitle);
                                    const itemPrice = selector.selectedOptions[0].getAttribute(selectors.variantPriceWithoutCurrency);
                                    const itemSKU = selector.selectedOptions[0].getAttribute(selectors.variantSKU);
                                    window.dataLayer.push({
                                        event: 'add_to_cart',
                                        ecommerce: {
                                            currency: currency,
                                            value: items_subtotal_price,
                                            items: [
                                                {
                                                    item_id: itemSKU,
                                                    item_name: itemName,
                                                    item_variant: itemVariant,
                                                    price: itemPrice,
                                                    quantity: 1,
                                                    index: index,
                                                    item_list_id: 'cart-drawer-recommendations',
                                                    item_list_name: 'Cart Drawer Recommendations',
                                                },
                                            ],
                                        },
                                    });
                                    // Data Layers -- End
                                    window.dispatchEvent(new CustomEvent('frank-green:quick-add-update', {}));
                                })
                                    .catch((err) => {
                                    console.error(err);
                                });
                            });
                        });
                    }
                });
            }
        }
    };
    const prepareRecommendationsAndCarousel = () => __awaiter(void 0, void 0, void 0, function* () {
        yield dynamicRecommendations();
        recommendedProductsCarousel();
    });
    prepareRecommendationsAndCarousel();
    window.addEventListener('frank-green:cart-reloaded', () => {
        prepareRecommendationsAndCarousel();
    });
};
export { cartDrawerRecommendations };
